export const DefaultSizes = {
  m: "medium",
  l: "large",
};
export const S_Sizes = { s: "small" };
export const Xs_Sizes = { ...S_Sizes, xs: "xsmall" };
export const Xl_Sizes = { xl: "xlarge" };

export type SizeType = keyof typeof DefaultSizes;

export type SizeProps = {
  /** The size to use */
  size?: SizeType;
};

// The below can probably be produced with some typescript generic magic. cba
export type SizePropsWithXl = {
  /** The size to use */
  size?: SizeType | keyof typeof Xl_Sizes;
};

export type SizePropsWithS = {
  /** The size to use */
  size?: SizeType | keyof typeof S_Sizes;
};

export type SizePropsWithXs = {
  /** The size to use */
  size?: SizeType | keyof typeof S_Sizes | keyof typeof Xs_Sizes;
};

/** @aurora/widgets-react prop -> @aurora/style sass className selector mapping */
export const SizeMap = {
  ...DefaultSizes,
  ...Xl_Sizes,
  ...S_Sizes,
  ...Xs_Sizes,
};
